<img src="assets/img/{{icon}}.png" class="dialog-icon" />
<div class="row">
  <b class="col-12 dialog-title"
    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
    {{ "dialog." + dialogType + ".title" | translate }}
  </b>
  <!-- <b class="col-12 dialog-info" *ngIf="dialogType === 'update_success' && platform === 'im3' ">
    {{ "dialog." + dialogType + ".info_im3" | translate }}
  </b>
  <b class="col-12 dialog-info" *ngIf="dialogType === 'update_success' && platform === 'tri' ">
    {{ "dialog." + dialogType + ".info_tri" | translate }}
  </b> -->
  <b class="col-12 dialog-text"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    {{ "dialog." + dialogType + ".content" | translate }}
  </b>
  <div class="box-info"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <img src="assets/img/alert-icon-black.png" class="icon-info" />
    {{ "success_notif" | translate }}
  </div>
  <!-- <div class="col-12" *ngIf="showButton">
    <a class="btn btn-action" [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri',
    'bg-orange' : platform === 'tri'}" (click)="doAction()">
      {{ "dialog." + dialogType + ( platform === 'im3' ? '.btn_1_im3' : (platform === 'tri' ? '.btn_1_tri' : '.btn_1') )
      | translate }}
    </a>
  </div> -->
  <div class="col-12" *ngIf="dialogType === 'update_warning' ">
    <a class="btn btn-cancel"
      [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri'}"
      (click)="close()">
      {{ "dialog." + dialogType + ".btn_2" | translate }}
    </a>
  </div>
</div>